import { css, Theme } from '@emotion/react'
import { helpers, typography, z } from '@/styles'

export const styles = (theme: Theme) => ({
  track: {
    main: css`
      display: flex;
      flex-direction: column;

      width: 180px;
    `,

    cover: {
      main: css`
        position: relative;

        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        width: 180px;
        height: 180px;

        background-color: ${theme.colors.primary.darker};
        border-radius: 4px;
        overflow: hidden;

        margin-bottom: 10px;

        &: hover > div {
          opacity: 1;
        }
      `,

      overlay: {
        main: css`
          z-index: ${z.features.track.tile.overlay};

          position: absolute;
          left: 0;
          top: 0;

          width: 100%;
          height: 100%;

          transition: opacity 0.2s;
          opacity: 0;

          background-color: ${theme.colors.primary.normal}A0;
        `,
        button: css`
          ${helpers.resetDefaults};

          display: flex;
          align-items: center;
          justify-content: center;

          width: 100%;
          height: 100%;

          cursor: pointer;

          & > svg {
            width: 30px;
            height: 30px;

            & path {
              fill: ${theme.colors.accent.normal};
            }
          }
        `,
      },

      lock: {
        main: css`
          display: flex;
          flex-direction: column;
          align-items: center;
        `,
        icon: css`
          display: flex;

          & > svg {
            width: 30px;
            height: 30px;
          }
        `,
      },
    },

    description: {
      main: css`
        display: flex;
        flex-direction: column;
      `,
      name: css`
        ${helpers.textOverflowEllipsis};

        font-size: ${typography.p};
        font-weight: bold;
      `,
      author: css`
        ${helpers.resetDefaults};
        ${helpers.textOverflowEllipsis};

        cursor: pointer;

        font-size: ${typography.sp};
        color: ${theme.colors.secondary.normal};
        text-align: start;

        transition: color 0.2s;
        &:hover {
          color: ${theme.colors.accent.normal};
        }
      `,
    },
  },
})
